import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import { useGetAllMemberPapers } from "@api/members/papers/getAll";
import { useGetMemberPaper } from "@api/members/papers/get";
import { getApi } from "@api/apiPath";
import type { IPaperApprovePathParam } from "@api/members/papers/approve/path";
import { axiosClient, queryClient } from "@api/clients.ts";

const { getPath } = getApi("members.papers.paperApprove.post");

const postMemberPaperApprove: MutationFunction<
  unknown,
  IPaperApprovePathParam
> = ({ memberId, paperId, ...data }) => {
  return axiosClient.post(getPath({ memberId, paperId }), data);
};

export const usePostMemberPaperApprove = createMutation({
  mutationFn: postMemberPaperApprove,
  onSuccess: (_, { memberId, paperId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberPapers.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberPaper.getKey({ memberId, paperId }),
    });
  },
});
